import { Component, ViewContainerRef, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrderResponseStatus } from 'src/app/models/order.model';

export interface FailedOrderDialogData {
  eventInvalidOptions?: string[];
  hotelInvalidOptions?: string[];
  tourInvalidOptions?: string[];
  status?: OrderResponseStatus;
}

@Component({
  selector: 'app-failed-order-dialog',
  templateUrl: './failed-order-dialog.html',
  styleUrls: ['./failed-order-dialog.scss'],
})
export class FailedBookingDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<FailedBookingDialogComponent>,
    private viewContainerRef: ViewContainerRef,
    @Inject(MAT_DIALOG_DATA) public data: FailedOrderDialogData
  ) {}

  public navigateToCart() {
    this.dialogRef.close({});
  }

  public get paymentFailed() {
    return this.data.status === OrderResponseStatus.PaymentFailed;
  }

  public get noAvailability() {
    return this.data.status === OrderResponseStatus.NoAvailability;
  }

  public get height(): number {
    const dialogElement = this.viewContainerRef.element.nativeElement.parentElement as HTMLElement;
    const { height } = dialogElement.getBoundingClientRect();

    return height;
  }
}
